import $ from 'jquery';
import Change from './Change';

const BREAKPOINT = 1200;

export default class SocialRelocate {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.$body = this.getBody();
    this.update();
    this.register();
  }

  register() {
    Change.onChange(this.update.bind(this));
  }

  update() {
    const mobileActive = this.$body.find('.flyout .header-social-links').length > 0;
    const desktopActive = this.$body.find('.toolbar .header-social-links').length > 0;
    if (($(window).outerWidth(true) < BREAKPOINT) && (desktopActive)) {
      this.$element.appendTo(this.$body.find('.flyout .inner'));
    } else if (($(window).outerWidth(true) >= BREAKPOINT) && (mobileActive)) {
      this.$element.prependTo(this.$body.find('.toolbar'));
    }
    this.$element.addClass('ready');
    return this;
  }

  getBody() { return $(document.body, this.context); }
}
